<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        产品简介
      </p>
      <div class="content_A">
        <div>
          针对网络安全事件提供应急处置措施的实用性工具，该工具箱内置了多个应急处置功能，通过该工具箱，可以帮助用户及时有效的处理紧急发生的网络安全事件，进而提升用户自身的应急响应的处置能力。
        </div>
      </div>
      <div class="content_A center_img">
        <img
          src="@/assets/Emergencykit/pic1.png"
          alt=""
        >
      </div>
      <div class="content_A center_img">
        <img
          src="@/assets/Emergencykit/pic2.png"
          alt=""
        >
      </div>
    </div>
    <div class="introduce">
      <p class="sub_title">
        产品功能
      </p>
      <div
        v-for="fun in functionList"
        :key="fun.id"
        class="content_A"
      >
        <p>{{ fun.title }}</p>
        <div>
          {{ fun.content }}
        </div>
        <div class="img">
          <img
            :src="fun.imgUrl"
            alt=""
          >
        </div>
      </div>
    </div>
    <div class="introduce">
      <p class="sub_title">
        用户价值
      </p>
      <div
        v-for="value in UserValue"
        :key="value.id"
        class="content_A"
      >
        <div class="img">
          <img
            :src="value.imgUrl"
            alt=""
          >
        </div>
        <p>{{ value.title }}</p>
        <div class="valueContent">
          {{ value.content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Risk',
  components: {
    banner
  },
  data() {
    return {
      title: '灵创网络安全应急工具箱系统',
      content: '',
      functionList: [
        {
          id: 1,
          title: '应急处置场景化',
          imgUrl: require('@/assets/Emergencykit/pic3.png'),
          content:
            '针对应急事件进行场景化分类，可以快速、高效进行应急处置。常见的应急处置场景包括但不限于以下：勒索病毒、挖矿木马、Webshell、网页篡改、DDoS攻击、数据泄露、流量劫持。'
        },
        {
          id: 2,
          title: '响应分析流程化',
          imgUrl: require('@/assets/Emergencykit/pic4.png'),
          content:
            '在现场处置过程中，确定事件类型与事件范围，从系统排查、进程排查、服务排查、文件痕迹排查、日志分析等方面进行，整合相关信息，进行关联推理，最后给出事件结论。'
        },
        {
          id: 3,
          title: '安全应急知识库',
          imgUrl: require('@/assets/Emergencykit/pic5.png'),
          content:
            '通过提供相关的处置方法、相关预案及案例，对突发事件的处理带来便利，有助于其进行科学有效的应急指挥。完善应急管理机制，减少突发事件造成的损失具有重要意义。'
        },
        {
          id: 4,
          title: '安全应急工具集',
          imgUrl: require('@/assets/Emergencykit/pic6.png'),
          content:
            '应急处置工具集(包括但不限于病毒木马专杀工具、专杀脚本等或具备高可操作性的应急处置方法)，所采用的应急工具和方法能对安全威胁明显缓解，确保威胁程度不出现反弹。'
        }
      ],
      UserValue: [
        {
          id: 1,
          title: '打造科学合理的安全闭环能力',
          imgUrl: require('@/assets/Emergencykit/pic7.png'),
          content:
            '对安全事件快速分析，快速响应，最终实现问题早发现、快响应、早根除，有效合理的安全闭环能力。'
        },
        {
          id: 2,
          title: '提升突发安全事件应急响应能力',
          imgUrl: require('@/assets/Emergencykit/pic8.png'),
          content:
            '制定和完善网络安全应急预案，健全突发网络安全事件的应急协同配合机制，强化对网络安全突发事件的统一指挥和协调。'
        },
        {
          id: 3,
          title: '规范安全运行流程',
          imgUrl: require('@/assets/Emergencykit/pic9.png'),
          content:
            '梳理安全运行流程，加强对流程的技术化，强调流程的可重用性和强制性。'
        },
        {
          id: 4,
          title: '降低用户安全事件损失与影响 ',
          imgUrl: require('@/assets/Emergencykit/pic10.png'),
          content:
            '及时进行网络安全事件的处置，最大程度的减少给用户带来的损失与影响。'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
.center_img {
  display: flex;
  justify-content: center;
}
.center_img img{
  max-width: 100%;
}
.img {
  display: flex;
  justify-content: center;
}
.content_A p {
  text-align: center;
}
.valueContent {
  display: flex;
  justify-content: center;
}
</style>
